import { observer } from 'mobx-react';
import { Instance } from 'mobx-state-tree';
import * as React from 'react';
import { newDataviewStoreColumn } from '../../../stores/DataviewStoreColumn';
import { EntityEditDialog } from '../../EntityEditDialog';
import { TemplDetailsStore } from './TemplDetailsStore';

const columnsMap = Object.fromEntries(Object.entries({
	BRANCH: [
		'*name',
		'street',
		'number',
		'zipcode',
		'town',
		'phone',
		'fax',
	],
	SUPPLIER: [
		'*name',
		'email',
		'zipcode',
		'industry :Supplier_Industry',
	],
	TEMPLATE: [
		'*customerNo',
		'*zipcode',
	],
}).map(([k, v]) => [k, v.map(newDataviewStoreColumn)]));

function _TemplEditDialog(props: {store: Instance<typeof TemplDetailsStore>}) {
	const {store} = props;
	const columns = columnsMap[store.state];
	return !columns ? null : <EntityEditDialog store={store} columns={columns}/>;
}

export const TemplEditDialog = observer(_TemplEditDialog);
